import styled from '@emotion/styled';

export const SContainer = styled.div``;

export const SControlsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px;
  align-items: center;
  gap: 0 16px;
`;

export const SScrollNavWrapper = styled.div`
  margin-left: auto;
`;

export const SInnerFiltersFormWrapper = styled.div`
  display: flex;
  gap: 0 16px;
  min-height: 54px;
`;
